import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { DropFileComponent } from '../drop-file/drop-file.component';
import { GalleryModalComponent } from '../gallery-modal';

@Component({
    selector: 'app-drop-pics-gallery',
    templateUrl: './drop-pics-gallery.component.html'
})

export class DropPicsGalleryComponent {
    totalSize: number = 0;
    @Input() limit = 2700000;
    @Input() dropFileContainerClass = "";
    @Input() filesContainerClass = "";
    @Output() change = new EventEmitter();
    @ViewChild(DropFileComponent) drop: DropFileComponent;
    @ViewChild(GalleryModalComponent) gallery: GalleryModalComponent;
    filesToDelete = [];
    constructor() { }

    private handleSize(size: number) {
        this.totalSize += size;
        if (size > 0 && this.totalSize > this.limit) this.drop.overSized(this.totalSize);
        if (size < 0 && this.totalSize <= this.limit) this.drop.clearMessages();
    }

    private dropFilesHandler(files: any) { // Expects {data: [files], size: totalSize}
        files.data = files.data.map(file => {
            this.setUserInputFlag(file, true);
            return file;
        });
        this.addFiles(files);
    }

    get disabled() {
        return this.limit && this.totalSize > this.limit;
    }
    get filesToUpload() {
        return this.gallery.getFiles().filter(file => this.isUserInput(file));
        /* This returns a reference. Any change on this value returned also
        changes _files content.
        */
    }

    isUserInput(file) {
        return file && 'isUserInput' in file;
    }
    setUserInputFlag(file, flag: boolean) {
        file.isUserInput = flag;
    }

    addFiles(files) { // Expects {data: [files], size: totalSize}
        if (this.limit) {
            this.handleSize(files.size);
        }
        this.gallery.addFiles(Array.from(files.data));
        this.change.emit(this.gallery.getFiles());
    }
    setFiles(files) { // Expects {data: [files], size: totalSize}
        this.totalSize = files.size;
        this.gallery.setFiles(Array.from(files.data));
        this.change.emit(this.gallery.getFiles());
    }
    deleteImage(image) {
        if (this.isUserInput(image)) {
            if (this.limit) {
                this.handleSize(-image.size);
            }
        }
        else {
            this.filesToDelete.push(image);
        }
        this.change.emit(this.gallery.getFiles());
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/drop-pics-gallery/drop-pics-gallery.component.ts